import { DbAuditPosition } from "../../../data/usecases/audit-position";
import { AuditPosition } from "../../../domain/usecases/audit-position";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbAuditPosition = (): AuditPosition =>
  new DbAuditPosition(
    makeApiUrl("/position/audit"),
    makeAuthorizeHttpClientDecorator()
  );
